import { CARD_TYPE } from 'common/constants';
import { InfoFacade } from 'common/utils/facades/info-card-facade';
import { TriviaFacade } from 'common/utils/facades/trivia-card-facade';
import { PollFacade } from 'common/utils/facades/poll-card-facade';
import { PersonalityTestFacade } from 'common/utils/facades/personality-test-card-facade';
import { ThisOrThatFacade } from 'common/utils/facades/this-or-that-card-facade';
import { TrueOrFalseFacade } from 'common/utils/facades/true-or-false-card-facade';
import { NavigationFacade } from 'common/utils/facades/navigation-card-facade';
import { FormFacade } from 'common/utils/facades/form-card-facade';
import { RegistrationFacade } from 'common/utils/facades/registration-card-facade';
import { SandboxFacade } from 'common/utils/facades/sandbox-card-facade';

const facades = {
	[CARD_TYPE.INFO]: InfoFacade,
	[CARD_TYPE.TRIVIA]: TriviaFacade,
	[CARD_TYPE.POLL]: PollFacade,
	[CARD_TYPE.PERSONALITY_TEST]: PersonalityTestFacade,
	[CARD_TYPE.TRUE_OR_FALSE]: TrueOrFalseFacade,
	[CARD_TYPE.THIS_OR_THAT]: ThisOrThatFacade,
	[CARD_TYPE.NAVIGATION]: NavigationFacade,
	[CARD_TYPE.FORM]: FormFacade,
	[CARD_TYPE.REGISTRATION]: RegistrationFacade,
	[CARD_TYPE.SANDBOX]: SandboxFacade,
} as const;

export type FacadeKeys = keyof typeof facades;
export type FacadeValues =
	| InfoFacade
	| TriviaFacade
	| PollFacade
	| PersonalityTestFacade
	| ThisOrThatFacade
	| TrueOrFalseFacade
	| NavigationFacade
	| FormFacade
	| SandboxFacade;
export default facades;
